<div class="gridLayout">
	<sim-labelled-container icon="fa-cube" label="CREATE_SESSION_DIALOG_CREATE_SESSION">
		<!--TITLE-->
		<mat-form-field color="accent">
			<mat-label>
				<mat-icon fontIcon="fa-signature" fontSet="fad" />
				{{ T.CREATE_SESSION_DAILOG_SESSION_NAME | translate }}
			</mat-label>
			<input [formControl]="metadataForm.controls.title" matInput />
		</mat-form-field>

		<!--DATE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label><mat-icon fontIcon="fa-calendar-day" fontSet="fad" />{{ T.LABEL_DATE | translate }}</mat-label>
			<input
				(click)="datepicker.open()"
				[formControl]="metadataForm.controls.date"
				[matDatepicker]="datepicker"
				[max]="eventEndDate()"
				[min]="eventStartDate()"
				matInput
				readonly
			/>
			<mat-error>
				{{ T.ERROR_INVALID | translate: {item: T.LABEL_DATE | translate} }}
			</mat-error>
			<mat-datepicker-toggle [for]="datepicker" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fad" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepicker />
		</mat-form-field>

		<!--START TIME-->
		<sim-clock-time-input [formCtrl]="metadataForm.controls.startTime" [labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_START" />

		<!--RUN TIME-->
		<mat-form-field color="accent">
			<mat-label><mat-icon fontIcon="fa-stopwatch" fontSet="fad" /> {{ T.PEER_PRACTICE_SESSION_RUN_DURATION | translate }}</mat-label>
			<input
				[formControl]="metadataForm.controls.runDurationMinutes"
				[maxlength]="2"
				class="digitInput"
				matInput
				pattern="[0-9]*"
				type="text"
			/>
			<span matTextSuffix>{{ T.LABEL_MINUTES | translate }}</span>
			<mat-error>{{ T.ERROR_REQUIRED | translate }}</mat-error>
		</mat-form-field>
	</sim-labelled-container>
	<mat-divider vertical />
	<sim-list [floatingLabel]="true" class="stationList" icon="fa-cubes" label="CREATE_SESSION_DIALOG_LIST_OF_STATIONS">
		<ng-container actions>
			<sim-new-list-item
				(add)="addStation()"
				[disabled]="metadataForm.invalid || stationFormArray.invalid"
				buttonLabel="BUTTON_CREATE"
				class="default"
				primaryLabel="CREATE_SESSION_DIALOG_NEW_STATION"
			/>
		</ng-container>
		@for (station of stationFormArray.controls; track $index) {
			@let isValid = stationFormArray.at($index)?.valid;
			@let preventSelection = activeStationIndex() !== $index && stationFormArray.invalid;

			<sim-list-item
				#listItem
				(onClick)="selectStation($index)"
				[invalid]="!isValid"
				[preventSelection]="preventSelection"
				[primaryLabel]="isValid ? station.value?.trainingRoom?.name : (T.CREATE_SESSION_DIALOG_STATION_LIST_ITEM_EMPTY | translate)"
				[secondaryLabel]="isValid ? station.value.scenarios.length + ' ' + (T.LABEL_SCENARIO | translate) : null"
				[selected]="activeStationIndex() === $index"
				[tooltip]="listItem.preventSelection() ? (T.ERROR_STATION_FORM_INVALID | translate) : null"
				indicator="{{ $index + 1 }}"
			>
				<ng-container actions>
					<button (click)="deleteStation($index)" [disabled]="preventSelection" color="warn" mat-icon-button>
						<mat-icon fontIcon="fa-trash-alt" fontSet="fas" inline />
					</button>
				</ng-container>
			</sim-list-item>
		}
	</sim-list>
	<sim-labelled-container icon="fa-cube" label="CREATE_SESSION_DIALOG_STATION_CONFIG">
		@if (this.activeStationForm()) {
			@if (!isFormCooldown()) {
				<!--TRAINING ROOM-->
				<sim-chip-autocomplete
					(onLoad)="isLoadingForms.set(false)"
					[dataType]="FetchDataType.TrainingRoom"
					[excludeIds]="excludeRoomIds()"
					[formCtrl]="activeStationForm().controls.trainingRoom"
					[labelToken]="T.CREATE_SESSION_DIALOG_TRAINING_ROOM_LABEL"
				>
					<ng-container labelPrefix>
						<mat-icon fontIcon="fa-door-open" fontSet="fad" />
					</ng-container>
				</sim-chip-autocomplete>

				<!--SCENARIO-->
				<sim-list class="scenarioList" icon="fa-ballot-check" label="{{ T.LABEL_SCENARIO }}">
					<div actions class="scenarioListActions">
						<sim-autocomplete
							(onSelect)="addScenario($any($event))"
							[dataType]="FetchDataType.Scenario"
							[excludeIds]="excludeScenarioIds()"
							[labelToken]="T.PEER_PRACTICE_STUDENT_APP_SELECT_SCENARIO"
							[searchFilters]="{searchColumn: '**peerPracticeAssessment**', searchTerms: []}"
						/>
						<sim-info-hover [tooltip]="'Only scenarios with assessments can be used in Peer Practice sessions'" />
					</div>

					@for (scenario of activeStationForm().value.scenarios; track scenario.id) {
						<sim-list-item [primaryLabel]="scenario.name" [selectable]="false" indicator="{{ $index + 1 }}">
							<ng-container actions>
								<button (click)="removeScenario(scenario)" color="warn" mat-icon-button>
									<mat-icon fontIcon="fa-trash-alt" fontSet="fas" inline />
								</button>
							</ng-container>
						</sim-list-item>
					}
				</sim-list>
			} @else {
				<div class="emptyState secondary">
					<mat-spinner color="accent" />
				</div>
			}
		} @else {
			<div class="emptyState secondary">
				<mat-icon fontIcon="fa-empty-set" fontSet="far" />
				<label>{{ T.GENERAL_TXT_LIST_EMPTY | translate }}</label>
			</div>
		}
	</sim-labelled-container>
	<section>
		<sim-component-loading-container [isLoading]="isLoadingForms()" [showBackDrop]="true" loadingIcon="fad fa-cube" />
	</section>
</div>
